import type { PartialMessage } from "@bufbuild/protobuf";
import { ClientContext } from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/models_pb";
import type {
  ConversationClientContext,
  ConversationClientScenario,
} from "../types";

// Simple wrapper around the ClientContext constructor
// that ensures type safety around clientScenario as it is typed as a string on the backend
export function createConversationClientContext(
  scenario: ConversationClientScenario,
  options?: Omit<PartialMessage<ClientContext>, "clientScenario">,
): ConversationClientContext {
  return new ClientContext({
    clientScenario: scenario as string,
    ...options,
  });
}
